import { render, staticRenderFns } from "./ProductSuggestions.vue?vue&type=template&id=0f64be6e"
import script from "./ProductSuggestions.vue?vue&type=script&lang=js"
export * from "./ProductSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports